export default __webpack_public_path__ + "static/media/person_1.ce87d7c6.png";